const purchaseProcessSidebar = document.querySelector('.purchase-process-sidebar');

if (purchaseProcessSidebar) {
  // **************************************************
  // Dropdown
  // **************************************************
  const purchaseProcessHeader = purchaseProcessSidebar.querySelector('.purchase-process-sidebar__header');
  purchaseProcessHeader.addEventListener('click', () => {
    const content = purchaseProcessSidebar.querySelector('.purchase-process-sidebar__content');
    slideToggle(content, 300, 'block');
    purchaseProcessSidebar.classList.toggle('is-open');
  });

  // **************************************************
  // Focus event
  // **************************************************
  // const couponFields = purchaseProcessSidebar.querySelectorAll('.purchase-process-sidebar__input input');
  // couponFields.forEach((couponField) => {
  //   const parent = couponField.closest('.purchase-process-sidebar__input');
  //   couponField.addEventListener('focus', () => {
  //     parent.classList.add('is-focused');
  //   });

  //   couponField.addEventListener('blur', () => {
  //     if (!couponField.value) {
  //       parent.classList.remove('is-focused');
  //     }
  //   });
  // });

  // **************************************************
  // Submit coupon/giftcard
  // **************************************************
  // const couponBtns = purchaseProcessSidebar.querySelectorAll('.purchase-process-sidebar__input .btn');
  // couponBtns.forEach((couponBtn) => {
  //   couponBtn.addEventListener('click', () => {
  //     const parent = couponBtn.closest('.purchase-process-sidebar__input-parent');
  //     const inputDiv = parent.querySelector('.purchase-process-sidebar__input');
  //     const sentDiv = parent.querySelector('.purchase-process-sidebar__input-sent');
  //     const sentClone = sentDiv.cloneNode(true);
  //     const inputValue = parent.querySelector('input').value;
  //     const codeDiv = sentClone.querySelector('.purchase-process-sidebar__input-sent__code');

  //     inputDiv.classList.add('is-hidden');
  //     parent.insertBefore(sentClone, inputDiv);
  //     sentClone.classList.add('is-active');
  //     codeDiv.innerHTML = inputValue;

  //     const inputDivInput = inputDiv.querySelector('input');
  //     const add = sentClone.querySelector('.add');

  //     add.addEventListener('click', () => {
  //       inputDivInput.value = '';
  //       inputDiv.classList.remove('is-focused');
  //       inputDiv.classList.remove('is-hidden');
  //     });

  //     const remove = sentClone.querySelector('.remove');
  //     remove.addEventListener('click', () => {
  //       const removeParent = remove.closest('.purchase-process-sidebar__input-sent');
  //       removeParent.remove();
  //       const sentDivs = parent.querySelectorAll('.purchase-process-sidebar__input-sent');
  //       if (sentDivs.length === 1) {
  //         inputDivInput.value = '';
  //         inputDiv.classList.remove('is-focused');
  //         inputDiv.classList.remove('is-hidden');
  //       }
  //     });
  //   });
  // });
}
